import React from "react";
import LogoHeader from '../../assets/images/logo-header.png';
import bgInfo from "../../assets/images/bg-menu-info.png";
import btnProfile from "../../assets/images/BTN-Profile.png";
import btnEmployee from "../../assets/images/BTN-Employee.png";
import btnCoupon from "../../assets/images/BTN-Coupon.png";
import useWindowDimensions from "../../functions/getScreen";
import { useNavigate } from "react-router-dom";

export default function TopBtnShop({ type, isOwner }) {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const ml = isOwner ? width / 7.8 : width / 3.9
    return (
        <>
            <div className="relative container m-auto">
                <img className="bg" src={bgInfo} alt="Snow" />
                <div className="btn flex" style={{ gap: `${width / 7.8}px`, left: `${ml}px`, top: `${width / 15.6}px` }}>
                    <button onClick={() => navigate('/shop-info')}>
                        <img className={type === 'info' ? "btn-info btn-info-active" : "btn-info"}
                            style={{ width: `${width / 7.8}px` }}
                            src={btnProfile} alt="Profile" />
                    </button>
                    {isOwner &&
                        <button onClick={() => navigate('/shop-employee')}>
                            <img className={type === 'employee' ? "btn-info btn-info-active" : "btn-info"}
                                style={{ width: `${width / 7.8}px` }}
                                src={btnEmployee} alt="Product" />
                        </button>
                    }
                    <button onClick={() => navigate('/shop-coupon')}>
                        <img className={type === 'coupon' ? "btn-info btn-info-active" : "btn-info"}
                            style={{ width: `${width / 7.8}px` }}
                            src={btnCoupon} alt="Previlege" />
                    </button>
                </div>

            </div>
        </>
    );
}
